import * as React from 'react';
export const allianceSvg = React.forwardRef(function allianceSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#002E5D',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M25.058 23.408H6.943v2.588h18.115v-2.588Z',
      fill: '#ED1C24',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.443 22.908h17.115V7.088H7.443v15.82Z',
      fill: '#294273',
      stroke: '#4972A2',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm16 4 11.645 19.408H4.355L16.001 4Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.001 6.012 6.184 22.373h19.633L16.001 6.012Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm16 17.76-3.134 5.225h6.269L16 17.761Z',
      fill: '#294273',
      stroke: '#294273',
    }),
  );
});
allianceSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var alliance = {
  category: 'brand',
  colorable: false,
  name: 'alliance',
  svg: allianceSvg,
};
